import App from "../../package.json";
import CSS from "./Variables.scss";

export const APP_NAME = App.name;
export const APP_VERSION = App.version;

export const CHAT_CENTER_NAME = "Customer support";
export const USERNAME = "super_admin";
export const PASSWORD = "Ut12345678!";
export const USER = "udaya";

export const NAV_BAR_HEIGHT = CSS.NAV_BAR_HEIGHT;
export const SIDE_BAR_WIDTH = CSS.SIDE_BAR_WIDTH;
